import { BaseViewUI } from './BaseViewUI/BaseViewUI';


/**
 * BaseDisplay
 *
 * Displayのベースクラス
 */
export abstract class BaseDisplay extends BaseViewUI {

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのコントローラーと紐づくか明示する為。
	public combineCtrl: any;

	constructor() {
		super();

	}

}
